export default {"src":"/_next/static/media/icon.1f3763e5.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};